<template>
    <div>
        <!-- ---------ThE HEADER SECTION--------------------- -->
        <the-header></the-header>

        <!-- -----------------THE BANNER INTRO SECTION------------------------ -->
        <section class=" pb-20 md:pb-6">

            <div class="background-image flex justify-center text-center pb-12 pt-10">
                <div>
                    <p class=" font-extrabold font-poppins mt-32 text-blue-700 text-6xl md:text-4xl lg:leading-7">
                        Delivery at the</p>
                    <p class="text-center font-extrabold font-poppins mt-4 text-blue-700 text-6xl md:text-4xl">speed of
                        thought</p>
                    <p class=" font-poppins text-xl mt-8 text-blue-700 font-medium ">Download the CarryGo App on</p>

                    <div class=" mt-8 font-montserrat">
                        <a style="text-decoration: none "
                            href="https://play.google.com/store/apps/details?id=org.carrygo.user"><button
                                class=" bg-blue-700 text-white p-4 rounded-3xl w-40 font-semibold border text-lg  hover:border-blue-700 hover:bg-transparent hover:text-blue-700">Play
                                store</button></a>
                        <a style="text-decoration: none "
                            href="https://apps.apple.com/ng/app/carrygo-app/id1626450079"><button
                                class=" sm:mt-1 sm:ml-0 border border-blue-700 font-semibold text-lg p-4 text-blue-700 rounded-3xl w-40 ml-4 hover:bg-blue-700 hover:text-white">App
                                store</button></a>
                    </div>
                </div>
            </div>


            <!-- -------- PHONE IMAGE SECTION------------ -->

            <div class=" flex justify-center">
                <!-- <img  class=" lg:w-1/2 h-1/2 mr-32 lg:mr-2" src="https://res.cloudinary.com/https-carrygo-com/image/upload/v1634104976/carrygoWebAssets/Rectangle-phone_2_mj2pxb.png" alt="phone1"> -->
                <img class=""
                    src="https://res.cloudinary.com/https-carrygo-com/image/upload/v1644221832/carrygoWebAssets/Group_11143_iosfye.png"
                    alt="phone2">
            </div>



            <!-- -------WHY USE CARRY GO---------------- -->

            <div>
                <Services />
            </div>

            <!-- -----------FEATURES OF THE APP-------------- -->

            <div class=" mt-20 mb-20">
                <AppFeatures />
            </div>

            <hr class=" w-1/2 m-auto border border-gray-300 lg:w-full">

            <!-- --------START NOW FOUR EASY MADE STEPS------------- -->
            <div class=" pt-12">
                <EasySteps />
            </div>

            <!-- ----------------------CUSTOMERS FEEDBACK-------------------- -->

            <div>
                <Reviews />
            </div>


            <!-- --------- DOWNLOAD APP -->
            <div class=" font-poppins bg-blue-700 pt-20 pb-20 text-white" id="downloadApp">
                <div class=" w-1/2 m-auto md:w-full md:p-2">
                    <div class=" text-center">
                        <p class=" text-3xl">Download the app now.</p>
                        <p class=" mt-10 text-gray-200">Available on your favourite App stores, start your premium
                            experience now.</p>
                    </div>

                    <div class=" flex flex-row justify-center mt-10">
                        <a style="text-decoration: none "
                            href="https://play.google.com/store/apps/details?id=org.carrygo.user"><button
                                class=" bg-white text-blue-600 rounded-lg mr-6 p-4">Play store</button></a>
                        <a style="text-decoration: none "
                            href="https://apps.apple.com/ng/app/carrygo-app/id1626450079"><button
                                class=" bg-transparent text-white rounded-lg border border-white p-4">App
                                store</button></a>
                    </div>
                </div>

            </div>

            <!-- -------FAQs SECTION -->
            <div>
                <FAQs />
            </div>
        </section>
        <div>
            <the-footer></the-footer>
        </div>

        <div>
            <ComingSoonModal v-show="isModalVisible" @click="close" />
        </div>
    </div>
</template>

<script>
import TheFooter from '../../layout/TheFooter.vue';
import FAQs from './FAQs.vue';
import Reviews from './Review.vue';
import EasySteps from './EasySteps.vue';
import AppFeatures from './AppFeatures.vue';
import Services from './Services.vue';
import ComingSoonModal from '../ComingSoonModal.vue';
export default {
    components: {
        FAQs,
        AppFeatures,
        Reviews,
        Services,
        EasySteps,
        TheFooter,
        ComingSoonModal
    },

    data() {
        return {
            isModalVisible: false
        }
    },

    methods: {
        close() {
            this.isModalVisible = false;
        },

        downloadApp() {
            this.isModalVisible = true;
        }
    }
}
</script>

<style scoped>
.background-image {
    background-image: linear-gradient(rgb(255, 255, 255, 0.6), rgba(255, 255, 255, 0.5)), url('../Images/image 27.png');
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
}
</style>
